import React, { Component } from "react";
import AnimatedNumber from "animated-number-react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ApiConnect from "../../../../Utils/ApiConnect";
import moment from "moment";
import { connect } from "react-redux";
import { setStatistics } from "../../../../redux/actions/Modules.Action";
class Statistics extends Component {
  constructor(props) {
    ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend
    );
    super(props);

    this.options = {
      responsive: true,
      plugins: {
        legend: {
          position: "bottom",
        },
        animation: {
          delayed: true,
        },
        title: {
          display: true,
          text: "Sales And Revenue",
        },
      },
    };
  }

  componentDidMount = () => {
    this.fetchData(7);
  };
  fetchData = async (day) => {
    try {
      ApiConnect.get("/Dashboard/Summary/StatisticsData?from&to&days=" + day)
        .then((response) => {
          this.props.setStatistics(response.data);
        })
        .catch((err) => console.error(err));
    } catch (err) {
      console.log("error facing location:", err);
    }
  };
  render() {
    const formatValue = (value) => `${Number(value).toFixed()}`;
    const statData = this.props.sateData;
    const MonthArray = (data) => {
      const monthList = [...Array(12).keys()];
      var newData = [];
      monthList.map((mth) => {
        newData[mth] = newData[mth] || 0 + 0;
        data.data.map((va, i) => {
          const da = parseInt(moment(va).format("M")) - 1;
          if (da === mth) {
            newData[mth] += parseFloat(data.value[i]);
          }
        });
      });
      return newData;
    };
    const data = {
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      datasets: [
        {
          label: "Sales",
          data: statData ? MonthArray(statData.sales) : [],
          borderColor: "#faa64b",
          backgroundColor: "rgba(250,166,75,0.2)",
          fill: true,
          borderWidth: 1,
          lineTension: 0.5,
        },
        {
          label: "Customer",
          data: statData ? MonthArray(statData.customer) : [],
          borderColor: "#375caa",
          backgroundColor: "rgba(55,92,170,0.2)",
          fill: true,
          borderWidth: 1,
          lineTension: 0.5,
        },
        {
          label: "Product",
          data: statData ? MonthArray(statData.product) : [],
          borderColor: "#f96868",
          backgroundColor: "rgba(249,104,104,0.2)",
          fill: true,
          borderWidth: 1,
          lineTension: 0.5,
        },
        {
          label: "Purchase",
          data: statData ? MonthArray(statData.purchase) : [],
          borderColor: "#15c377",
          backgroundColor: "rgba(21,195,119,0.2)",
          fill: true,
          borderWidth: 0,
          lineTension: 0.5,
        },
      ],
    };
    return (
      <div className="col-12 col-md-12 col-xl-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Statistics</h4>
            <p className="card-text font-small-2 me-25 mb-0 card-text">
              <select
                className="form-control"
                onChange={(e) => this.fetchData(e.target.value)}
              >
                <option value="7">Last 7 Days</option>
                <option value="30">Last Month</option>
                <option value="60">Last 60 Days</option>
                <option value="120">Last 120 Days</option>
                <option value="120">Last 180 Days</option>
                <option value="120">Last 240 Days</option>
                <option value="120">Last 365 Days</option>
              </select>
            </p>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="mb-2 mb-xl-0 col-sm-6 col-xl-3">
                <div className="d-flex align-items-center">
                  <div className="avatar me-2 bg-warning">
                    <span className="avatar-content">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                        <polyline points="17 6 23 6 23 12" />
                      </svg>
                    </span>
                  </div>
                  <div className="my-auto">
                    <h4 className="fw-bolder mb-0">
                      <AnimatedNumber
                        value={statData ? statData.sales.total : 0}
                        formatValue={formatValue}
                      />
                    </h4>
                    <p className="font-small-3 mb-0 card-text">Sales</p>
                  </div>
                </div>
              </div>
              <div className="mb-2 mb-xl-0 col-sm-6 col-xl-3">
                <div className="d-flex align-items-center">
                  <div className="avatar me-2 bg-info">
                    <span className="avatar-content">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx={12} cy={7} r={4} />
                      </svg>
                    </span>
                  </div>
                  <div className="my-auto">
                    <h4 className="fw-bolder mb-0">
                      <AnimatedNumber
                        value={statData ? statData.customer.total : 0}
                        formatValue={formatValue}
                      />
                    </h4>
                    <p className="font-small-3 mb-0 card-text">Customers</p>
                  </div>
                </div>
              </div>
              <div className="mb-2 mb-sm-0 col-sm-6 col-xl-3">
                <div className="d-flex align-items-center">
                  <div className="avatar me-2 bg-danger">
                    <span className="avatar-content">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                        <line x1={12} y1="22.08" x2={12} y2={12} />
                      </svg>
                    </span>
                  </div>
                  <div className="my-auto">
                    <h4 className="fw-bolder mb-0">
                      <AnimatedNumber
                        value={statData ? statData.product.total : 0}
                        formatValue={formatValue}
                      />
                    </h4>
                    <p className="font-small-3 mb-0 card-text">Products</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-xl-3">
                <div className="d-flex align-items-center">
                  <div className="avatar me-2 bg-success">
                    <span className="avatar-content">
                      <span className="material-icons-outlined pt-2">
                        local_grocery_store
                      </span>
                    </span>
                  </div>
                  <div className="my-auto">
                    <h4 className="fw-bolder mb-0">
                      <AnimatedNumber
                        value={statData ? statData.purchase.total : 0}
                        formatValue={formatValue}
                      />
                    </h4>
                    <p className="font-small-3 mb-0 card-text">Purchase</p>
                  </div>
                </div>
              </div>
              <div className="m-2">
                <Line options={this.options} data={data} height={120} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    sateData: state.Dashboard.statistics,
  }),
  { setStatistics }
)(Statistics);
